import { render } from "./FormReadOnlyTextFieldComponent.vue?vue&type=template&id=e595f060"
import script from "./FormReadOnlyTextFieldComponent.vue?vue&type=script&lang=js"
export * from "./FormReadOnlyTextFieldComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__